import { Component, Input } from '@angular/core';
import { NgbActiveModal, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { DateHelperService } from '../../../shared/services/date-helper.service';
import { OverlayService } from '../../../shared/services/overlayService';
import { CustomDateParserFormatter } from '../../../shared/services/datepicker-adapter';
import moment from 'moment';

@Component({
  selector: 'mtm-project-completion-date',
  templateUrl: './project-completion-date.component.html',
  styleUrl: './project-completion-date.component.scss',
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter }],
  standalone: false,
})
export class ProjectCompletionDateComponent {
  @Input() project: any;

  maxDate: any;
  minDate: any;

  date: any = this.dateHelperService.fromDateToDatepicker(new Date(moment().toISOString()));

  constructor(
    private readonly activeModal: NgbActiveModal,
    private readonly dateHelperService: DateHelperService
  ) {}

  setParams(args) {
    this.project = args.project;
    this.maxDate = {
      year: parseInt(moment().format('YYYY')),
      month: parseInt(moment().format('M')),
      day: parseInt(moment().format('D')),
    };
    this.minDate = {
      year: parseInt(moment(this.project.startDate).format('YYYY')),
      month: parseInt(moment(this.project.startDate).format('M')),
      day: parseInt(moment(this.project.startDate).format('D')),
    };
  }

  submit() {
    this.activeModal.close({
      completionDate: this.dateHelperService.fromDateToApi(this.dateHelperService.fromDatePickerToDate(this.date)),
    });
  }

  cancel() {
    this.activeModal.close();
  }
}
